import { useEffect } from "react";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { fetchSession, sessionQueryKey, hasModule } from "@/lib/auth";
import { IntakeBak } from "@/features/intake/IntakeBak";
import { openInMainWindow, rememberIntakeWindowPlace } from "@/features/intake/intakeWindow";

// The invoerbak in a window of its own, for the second screen (docs/invoerbak.md §3): outside the shell, as the map of
// the planbord is (planning-map.tsx). A click opens the row on the main screen, over the bus; without a main window in
// a tab of its own. Where it stood is kept when it closes, so it opens there again.
export const Route = createFileRoute("/intake-window")({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.ensureQueryData({ queryKey: sessionQueryKey, queryFn: fetchSession });
    if (!session) throw redirect({ to: "/login", search: { redirect: location.href } });
    return { session };
  },
  component: IntakeWindow,
});

function IntakeWindow() {
  const { t } = useTranslation();
  const session = useQuery({ queryKey: sessionQueryKey, queryFn: fetchSession });
  useEffect(() => {
    document.title = t("intake.windowTitle");
    window.addEventListener("pagehide", rememberIntakeWindowPlace);
    return () => window.removeEventListener("pagehide", rememberIntakeWindowPlace);
  }, [t]);
  const allowed = session.data && (session.data.roles.includes("admin") || hasModule(session.data, "order_intake"));
  return (
    <div data-screen-label="Back-office Intake Window" style={{ padding: "var(--space-3)", height: "100vh", boxSizing: "border-box", background: "var(--surface-canvas)" }}>
      {session.data && !allowed ? (
        <span className="t-body-sm">{t("intake.noRight")}</span>
      ) : (
        <IntakeBak onOpen={openInMainWindow} onOpenOrder={(id) => window.open(`/orders/${id}`, "_blank")} />
      )}
    </div>
  );
}
